import { defineComponent as _defineComponent } from 'vue'
import { SdsSection8ExposureControl } from '@/interfaces/model/general/sds';
import {
  getSection8ACGIHCateoryList,
  getSection8ACGIHPropertyList,
} from '@/lib/formItem';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';
import { parseWithUnit } from '@/utils/section8';

type Props = {
  isEditing: boolean;
  exposureControls: SdsSection8ExposureControl[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'AcgihTable',
  props: {
    isEditing: { type: Boolean },
    exposureControls: null
  },
  emits: ["click:edit", "click:delete", "click:rescue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'click:edit', index: number): void;
  (e: 'click:delete', index: number): void;
  (e: 'click:rescue', index: number): void;
}), expose: any, slots: any, attrs: any }) {

const $t = i18n.t.bind(i18n);




const headerSection8 = [
  {
    text: $t(sharedMessages.materialName),
    value: 'materialName',
    sortable: false,
  },
  { text: $t(sharedMessages.casNumber), value: 'casNumber', sortable: false },
  {
    text: $t(sharedMessages.section8Property),
    value: 'property',
    sortable: false,
  },
  { text: $t(sharedMessages.category), value: 'category', sortable: false },
  {
    text: $t(sharedMessages.ppm),
    value: 'concentration',
    sortable: false,
  },
  { text: $t(sharedMessages.mgPerM3), value: 'amount', sortable: false },
  { text: $t(sharedMessages.other), value: 'other', sortable: false },
  { text: '', value: 'action', sortable: false },
];

const handleDeleteButtonClick = (index: number) => {
  emits('click:delete', index);
};

const handleRescueButtonClick = (index: number) => {
  emits('click:rescue', index);
};

const handleEditButtonClick = (index: number) => {
  emits('click:edit', index);
};

return { __sfc: true,$t, emits, headerSection8, handleDeleteButtonClick, handleRescueButtonClick, handleEditButtonClick, getSection8ACGIHCateoryList, getSection8ACGIHPropertyList, sharedMessages, parseWithUnit }
}

})